import { getSettingRscLipp } from "@faire/retailer-visitor-shared/settings/getSettingRscLipp";
import { getLocationOrThrow } from "@faire/web/common/globals/getLocation";
import { QueryParameters as SearchQueryParameters } from "@faire/web-api--source/routes/www/search";

// Helper to determine if the RSC version of the logged-in product page should be shown
export const shouldShowRSCLIPP = (isLoggedInRetailer: boolean) => {
  if (!isLoggedInRetailer) {
    return false;
  }
  const search = getLocationOrThrow().search;
  const rscParam = (
    SearchQueryParameters.parse(search) as Record<string, string | undefined>
  ).rsc;
  return getSettingRscLipp(rscParam);
};
